<template>
    <div  class="bg-white">
        <template v-if="isPageAllowed">
            <div class="wrap full-h">
                <div class="filter-bar mb20">
                    <el-form :inline="true" @submit.native.prevent="submitSearch">
                        <el-form-item label="项目：">
                            <el-input v-model.trim="tempQuery.project" clearable placeholder="名称、ID、包名、链接等关键字" @keyup.enter.native="submitSearch" style="width: 220px;"></el-input>
                        </el-form-item>
                        <el-form-item label="投放媒体：">
                            <ESelect v-model="tempQuery.plat_ids" multiple collapse-tags clearable placeholder="全部媒体" style="width: 140px;">
                                <el-option v-for="item in platList"
                                           :label="item.name"
                                           :value="item.id"
                                           :key="item.id">{{item.name}}
                                </el-option>
                            </ESelect>
                        </el-form-item>
                        <el-form-item label="创建/整合人：">
                            <ESelect v-model="tempQuery.creator_or_integrator" filterable multiple collapse-tags clearable placeholder="搜索或下拉选择" style="width: 200px;">
                                <el-option v-for="item in operatorList" :label="item.name" :value="item.id" :key="item.id">
                                    {{item.name}}
                                </el-option>
                            </ESelect>
                        </el-form-item>
                        <el-form-item label="创建/整合时间：">
                            <el-date-picker
                                v-model="tempQuery.range_time"
                                @change="submitSearch"
                                style="width: 220px"
                                type="daterange"
                                align="center"
                                unlink-panels
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                range-separator="~"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-button size="mini" type="primary" :loading="dataLoading" @click="submitSearch" style="width: 75px;" v-matomo="{behaviorCategory: '项目管理',name: '筛选' }">筛选</el-button>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-button size="mini" @click="resetForm" v-matomo="{behaviorCategory: '项目管理',name: '重置筛选' }">重置筛选</el-button>
                        </el-form-item>

                    </el-form>
                </div>
                <div class="tool-bar mb20">
                    <el-button size="mini" type="primary" class="" v-if="pageFuncNames.includes('add')" @click="showAddModal" v-matomo="{behaviorCategory: '项目管理',name: '添加项目' }">添加项目</el-button>
                    <el-button size="mini" @click="exportData" v-if="pageFuncNames.includes('export')" :loading="exportLoading" v-matomo="{behaviorCategory: '项目管理',name: '导出' }">导出</el-button>
                </div>
                <div class="data-list">
                    <jt-table
                        ref="table"
                        :data="dataList"
                        :header-cell-style="{background:'#e8eaec',color:'#333'}"
                        style="width:100%;"
                        v-loading="dataLoading"
                        :default-sort = "{prop: 'ci_time', order: 'descending'}"
                        @sort-change="handleSortChange"
                        @row-click="handleRowClick"
                        row-class-name="pointer"
                        @expand-change="handleExpandChange"
                    >
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <ExpandItem 
                                    :row="scope.row" 
                                    :editable="pageFuncNames.includes('edit')" 
                                    @edit="editSubProject"
                                    :project="tempQuery.project"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="300px"
                            property="project_name"
                            label="项目名称">
                            <template slot="header" slot-scope="scope">
                                <el-tooltip effect="dark" placement="top">
                                    <span class="pointer">项目名称 <i class="el-icon-question"></i></span>
                                    <div slot="content" style="max-width: 300px;line-height: 20px;">
                                        <p class="mb10">系统会按照规则自动整合，相同项目名称的产品将合并展示，可点击左侧icon展开查看具体包含产品;支持人工修改对应关系!</p>
                                        <p >自动整合规则:取产品名称“-”前的文字，忽略产品名称的副标题进行整合</p>
                                    </div>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.project_name||'--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            property="action"
                            label="操作"
                            width="120px"
                            align="center">
                            <template slot-scope="scope">
                                <span v-if="pageFuncNames.includes('edit')" class="el-icon-edit-outline text-color-primary font14px pointer action-btn mr10" @click.stop="editProject(scope.row)" title="编辑" v-matomo="{behaviorCategory: '项目管理',name: '列表(编辑)' }"></span>
                                <!-- 该功能在 产品录入 版本中删除 -->
                                <!-- <el-popconfirm
                                    v-if="pageFuncNames.includes('del')"
                                    placement="top"
                                    icon="el-icon-info"
                                    icon-color="red"
                                    confirm-button-type="danger"
                                    title="确认要删除吗，删除后不可恢复！"
                                    @confirm="deleteProject(scope.row)"
                                >
                                    <span slot="reference" class="el-icon-delete text-color-error font14px font14px pointer action-btn ml10" title="删除"></span>
                                </el-popconfirm> -->

                                <span v-if="!pageFuncNames.includes('edit')&&!pageFuncNames.includes('del')">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="200px"
                            property="plat_name"
                            label="投放媒体">
                            <template slot-scope="scope">
                                <span>{{scope.row.plat_name||'--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="150px"
                            property="creator_or_integrator"
                            label="创建/整合人">
                            <template slot-scope="scope">
                                <span>{{scope.row.creator_or_integrator||'--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="150px"
                            property="ci_time"
                            sortable="custom"
                            :sort-orders="['ascending','descending']"
                            label="创建/整合时间">
                            <template slot-scope="scope">
                                <span>{{scope.row.ci_time||'--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            min-width="120px"
                            property="note"
                            label="备注">
                            <template slot-scope="scope">
                                <span>{{scope.row.note||'--'}}</span>
                            </template>
                        </el-table-column>

                    </jt-table>
                    <div class="page-bar tac mt20">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryData.pn"
                            :page-size="queryData.rn"
                            :page-sizes="[30,50,100]"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCnt">
                        </el-pagination>
                    </div>
                </div>

                <AddProjectModal ref="addProjectModal" @update="getDataList"/>
                <EditProjectModal ref="editProjectModal" :data="activeProject" @update="getDataList" />
                <EditSubProjectModal ref="editSubProjectModal" :data="activeSubProject" @update="updateTableData" />
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>可在产品整合管理中查看和维护投放的所有主产品与标签管理。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import ExpandItem from './components/expandItem';
    import AddProjectModal from './modal/addProjectModal';
    import EditProjectModal from './modal/editProjectModal';
    import EditSubProjectModal from './modal/editSubProjectModal';
    import API from '@/api/baseInfo/project.js';

    export default {
        name: "ProjectPage",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            ExpandItem,
            AddProjectModal,
            EditProjectModal,
            EditSubProjectModal,
        },
        data(){
            return {
                tempQuery:{
                    project:'',
                    range_time:[],
                    plat_ids:[],
                    creator_or_integrator:[],
                },
                queryData:{
                    project:'',
                    plat_ids:'',
                    creator_or_integrator:'',
                    range_time:'',
                    pn:1,
                    rn:30,
                    order_by:'ci_time',
                    order_type:'desc',
                },
                totalCnt:0,
                operatorList:[],
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                    shortcuts:[
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                // 本周：自然周，周一到周日
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let weekDay = date.getDay();
                                let endDate = year+'-'+month+'-'+day;
                                let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                    ]
                },
                dataList:[],
                dataLoading:false,
                exportLoading:false,
                activeProject:{},
                activeSubProject:{},
                expandRows:[],
            }
        },
        computed:{
            platList(){
                return this.allowedPlatList||[];
            }
        },
        created(){
            this.getOperatorList();
            this.submitSearch();
        },
        mounted(){
        },
        methods:{
            handleExpandChange(row) {
                this.$nextTick(()=> {
                    const id = row._id;
                    const box = document.querySelector(`#${id}`);
                    if (!box) {
                        return;
                    };
                    const selectItem = box.querySelector('.sub-row-item.active');
                    if (!selectItem) {
                        return;
                    }
                    const {top} = selectItem.getBoundingClientRect();
                    // const appWrapper = document.querySelector('.app-wrapper');
                    window.scrollTo({
                        top: top - 50,
                        behavior: 'smooth'
                    })
                    // console.log(selectItem, top, '111');
                })
            },
            getOperatorList(){
                API.getOperatorList().then(res=>{
                    this.operatorList = res.data||[];
                },err=>{
                    console.log('getOperatorList err',err);
                    this.$message.error(err.info||'请求失败');
                    this.operatorList = [];
                })
            },
            submitSearch(){
                console.log('submitSearch');
                this.queryData.pn = 1;
                this.queryData.project = this.tempQuery.project;
                this.queryData.plat_ids = this.tempQuery.plat_ids;
                this.queryData.creator_or_integrator = this.tempQuery.creator_or_integrator;
                this.queryData.range_time = this.tempQuery.range_time?this.tempQuery.range_time.join('/'):'';
                this.getDataList();
            },
            updateTableData(row){
                this.getDataList(row);
            },
            getDataList(row){
                this.dataLoading = true;
                this.expandRows = [];
                API.getDataList({
                    project: this.queryData.project,
                    plat_ids: this.queryData.plat_ids,
                    creator_or_integrator:this.queryData.creator_or_integrator,
                    range_time: this.queryData.range_time,
                    order_by:this.queryData.order_by,
                    order_type:this.queryData.order_type,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list||[]).map((item , index)=>{
                        item.disableLoading = false;
                        item.enableLoading = false;
                        item._id = `_${index}_${item.project_id}`;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                    if(row){
                        /* 如果有 row,则表示需要展开某一行 */
                        let projectId = row.project_id||'';
                        let actionRow = this.dataList.find(item=>item.project_id==projectId);
                        if(actionRow){
                            this.$nextTick(()=>{
                                this.$refs.table.toggleRowExpansion(actionRow,true);
                                this.expandRows.push(projectId);
                            })
                        }
                    }
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            handleSortChange(column){
                this.queryData.order_type = column.order=='descending'?'desc':'asc';
                this.queryData.pn =1;
                this.getDataList();
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
            exportData(){
                this.exportLoading = true;
                API.exportOperatorList({
                    project: this.queryData.project,
                    plat_ids: this.queryData.plat_ids,
                    creator_or_integrator:this.queryData.creator_or_integrator,
                    range_time: this.queryData.range_time,
                }).then(res => {
                    this.exportLoading = false;
                    this.$message.success(res.info||'操作成功');
                }, (err) => {
                    this.exportLoading = false;
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            message: errData.join('；'),
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
            showAddModal() {
                console.log('showAddModal');
                this.$refs.addProjectModal.showModal();
            },
            resetForm(){
                console.log('resetForm');
                this.tempQuery.project = '';
                this.tempQuery.plat_ids = [];
                this.tempQuery.creator_or_integrator = [];
                this.tempQuery.range_time = [];
            },
            editProject(row){
                console.log('editProject',row);
                this.activeProject = {...row};
                this.$refs.editProjectModal.showModal();
            },
            deleteProject(row){
                API.deleteProject({
                    project_id:row.project_id,
                }).then(res=>{
                    this.$message.success(res.info || '操作成功');
                    this.getDataList();
                },err=>{
                    console.log('deleteProject error', err);
                    this.$message.error(err.info || '操作失败');
                })
            },
            editSubProject(row,data){
                this.activeSubProject = Object.assign({},row,{
                    project_name:data.project_name,
                    project_id:data.project_id,
                });
                console.log('editSubProject',this.activeSubProject);
                this.$refs.editSubProjectModal.showModal();
            },
            handleRowClick(row,column,event){
                let $target = event.target||{};
                let className = $target.className||'';
                if(className.includes('action-btn')) return false;

                let projectId = row.project_id||'';
                let index = this.expandRows.findIndex(item=>item==projectId);
                this.$refs.table.toggleRowExpansion(row,index===-1);
                if(index===-1){
                    this.expandRows.push(projectId);
                }else{
                    this.expandRows.splice(index,1);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar{
        background-color: #f8f8f9;
        padding: 12px 20px 0;
        border-radius: 5px;
        ::v-deep .el-form-item{
            margin-bottom: 12px;
        }
    }
    .data-list ::v-deep .el-table__expanded-cell{
        background-color: #f2f2f2!important;
    }
    .data-list ::v-deep .el-table__header th{
        padding: 4px 0;
    }

    .data-list ::v-deep .el-table__body td.el-table__cell{
        background: #FAFAFA;
    }

    .data-list ::v-deep .el-table__body td.el-table__cell.el-table__expanded-cell{
        background-color: #fff!important;
    }

</style>
